import Cookies from 'js-cookie'

const TokenKey = 'MDUSERTOKEN'
const IconKey = 'MDUSERINFO'

export function getToken(key = TokenKey) {
  return Cookies.get(key)
}

export function setToken(token, key = TokenKey) {
  return Cookies.set(key, token)
}

export function removeToken(key = TokenKey) {
  return Cookies.remove(key)
}

export function setStorage(key, value) {
  sessionStorage.setItem(key, value)
}
export function getStorage(key) {
  return sessionStorage.getItem(key)
}
// 获取用户icon
export function getIcon (key = IconKey) {
  return Cookies.get(key) || localStorage.getItem(key)
}
